<template>
  <div class="model-marker">
    <div class="model-marker-title">{{ item.name }}</div>
  </div>
</template>

<script>
export default {
  name: "ModelMarker",
  props: {
    item: { type: Object, default: {} },
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.model-marker {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  transform: translateY(-50%);

  &:after {
    content: "";
    width: 100%;
    height: 20px;
    background: url("../images/model-marker-arrow.png") no-repeat center center;
    background-size: auto 100%;
  }

  &-title {
    background: url("../images/model-marker-bg.png") no-repeat center center;
    padding: 0 10px;
    background-size: 100% 40px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    font-size: 12px;
  }
}
</style>
